import React from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@app/navigationApp/types';
import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { ThemedText, ThemedView } from '@app/theme';
import LottieView from 'lottie-react-native';
import { useKYCRedirectHandler } from './useKYCRedirectHandler';

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_DIGIO_REDIRECT'>;

const KYCRedirect = ({ navigation, route }: ScreenProps) => {
  useKYCRedirectHandler(navigation, route?.name);

  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
      <ThemedView alignItems="center" justifyContent="center" backgroundColor="bg-surface-primary" flex={1}>
        <LottieView source={require('../../../assets/lottie/sand_timer.json')} autoPlay={true} loop={true} />
        <ThemedText variant="h4s">
          Processing KYC redirect...
        </ThemedText>
      </ThemedView>
    </ScreenWrapper>
  );
};

export default KYCRedirect;